export default __webpack_public_path__ + "7c7ce72a31e770b57ce60685075c16c8.png";